import { v4 as uuid } from "uuid";
const formatBackendMessages = (messages = []) => messages.map((root) => {
  const { id: messageId, ...message } = root.message;
  return {
    ...root,
    frontendId: messageId != null ? messageId : uuid(),
    message: { ...message, _id: messageId }
  };
});
export default formatBackendMessages;
